module.exports = __webpack_public_path__ + "img/about-m-slide-12.3ea1b2e2.jpg";